export default __webpack_public_path__ + "bf3529104d96a23c22d7f5c7623d6360.png";